function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".logo-recruit-sp_svg__st94{fill:#516570}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.1 36.2c-2.7 0-5.1-.9-5.1-2.7 0-.6 1.1-5.5 4.9-10.1 1.8-2.1 4.3-4.5 7.7-6.3S20.5 14 26 14c1.6 0 3 .1 4.7.3.5.1.8.6.8 1.2-.1.8-.7 1.7-2.1 1.7-5.5 0-9.7 1.3-12.7 3.9-1.5 1.3-2.8 3-3.8 5s-1.7 4.5-2.2 7.3c-.4 2.1-4.1 2.8-5.6 2.8z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7 17.1C16.2 15.2 20.5 14 26 14c1.6 0 3 .1 4.7.3.5.1.8.6.8 1.2 0 .3-.1.7-.4 1-.3.4-.9.7-1.7.7-5.5 0-9.7 1.3-12.7 3.9-1.5 1.3-2.8 3-3.8 5s-1.7 4.5-2.2 7.3c0 .3-.1.5-.3.7-1 1.5-3.9 2-5.3 2-2.7 0-5.1-.9-5.1-2.7 0-.6 1.1-5.5 4.9-10.1 1.8-2.1 4.4-4.4 7.8-6.2z",
  fill: "#fefefe"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7 17.1C16.2 15.2 20.5 14 26 14c1.6 0 3 .1 4.7.3.5.1.8.6.8 1.2 0 .3-.1.7-.4.9-.3.4-.9.7-1.8.7-5.5 0-9.7 1.3-12.7 3.9-1.5 1.3-2.8 3-3.8 5s-1.7 4.5-2.2 7.3c0 .3-.1.5-.3.7-1 1.5-3.9 2-5.3 2-2.7 0-5.1-.9-5.1-2.7 0-.6 1.1-5.5 5-10.1 1.8-2 4.4-4.3 7.8-6.1z",
  fill: "#fdfdfd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8 17c3.4-1.8 7.8-3 13.2-3 1.6 0 3 .1 4.7.3.5.1.8.6.8 1.3 0 .3-.2.7-.4.9-.3.4-.9.7-1.8.7-5.5 0-9.6 1.3-12.7 3.9-1.5 1.3-2.8 3-3.8 5s-1.7 4.5-2.2 7.3c0 .3-.1.5-.3.7-1 1.5-3.9 2-5.3 2-2.7 0-5.1-.9-5.1-2.7 0-.6 1.1-5.5 5-10.1 1.9-2.1 4.4-4.5 7.9-6.3z",
  fill: "#fcfcfd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8 17c3.4-1.8 7.8-3 13.2-3 1.6 0 3 .1 4.7.3.5.1.8.6.8 1.3 0 .3-.2.7-.4.9-.4.4-.9.7-1.8.7-5.5 0-9.6 1.3-12.7 3.9-1.5 1.3-2.8 3-3.8 5s-1.7 4.5-2.2 7.2c0 .3-.1.5-.3.7-.9 1.5-3.9 2-5.3 2-2.7 0-5.1-.9-5.1-2.7 0-.6 1.1-5.5 5-10.1 1.9-2 4.4-4.4 7.9-6.2z",
  fill: "#fbfbfc"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8 17c3.4-1.8 7.8-3 13.2-3 1.6 0 3 .1 4.7.3.5.1.8.6.7 1.3 0 .3-.2.7-.4.9-.4.4-.9.7-1.8.7-5.5 0-9.6 1.3-12.7 3.9-1.5 1.3-2.8 3-3.8 5s-1.7 4.5-2.2 7.2c0 .3-.1.5-.3.7-.9 1.5-3.9 2-5.3 2-2.7 0-5.1-.9-5.1-2.7 0-.6 1.1-5.5 5-10.1 2-2 4.6-4.4 8-6.2z",
  fill: "#fafbfb"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9 17c3.4-1.8 7.8-3 13.2-3 1.6 0 3 .1 4.7.3.5.1.8.6.7 1.3 0 .3-.2.6-.4.9-.4.4-.9.7-1.8.7-5.5 0-9.6 1.3-12.7 3.9-1.5 1.3-2.8 3-3.8 5s-1.7 4.5-2.3 7.2c0 .3-.1.5-.3.7-.9 1.5-3.8 2-5.3 2-2.7 0-5.1-.9-5.1-2.7 0-.6 1.1-5.5 5-10.1 2-2 4.6-4.4 8.1-6.2z",
  fill: "#f9fafa"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9 17c3.4-1.8 7.7-3 13.1-3 1.6 0 3 .1 4.7.3.5.1.8.6.7 1.3 0 .3-.2.6-.4.9-.4.4-.9.7-1.8.7-5.5 0-9.6 1.3-12.6 3.9-1.5 1.3-2.8 3-3.8 5s-1.7 4.5-2.3 7.2c0 .3-.1.5-.3.7-.9 1.5-3.8 2-5.2 2-2.7 0-5.1-.9-5.1-2.7 0-.6 1.1-5.5 5-10.1 2-2 4.5-4.4 8-6.2z",
  fill: "#f8f9f9"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9 17c3.4-1.8 7.7-3 13.1-3 1.6 0 3 .1 4.7.3.5.1.8.6.7 1.3 0 .3-.2.6-.4.9-.4.4-.9.7-1.8.7-5.5 0-9.6 1.3-12.6 3.9-1.5 1.3-2.8 3-3.8 5s-1.7 4.4-2.3 7.2c0 .3-.1.5-.3.7-.9 1.5-3.8 2-5.2 2.1-2.7 0-5.1-.8-5.1-2.7 0-.6 1.1-5.5 5-10.1 2-2.2 4.5-4.5 8-6.3z",
  fill: "#f7f8f9"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M13 17c3.4-1.8 7.7-3 13.1-3 1.6 0 2.9.1 4.7.3.5.1.8.6.7 1.3 0 .3-.2.6-.4.9-.4.4-.9.7-1.8.7-5.5 0-9.6 1.3-12.6 4-1.5 1.3-2.8 3-3.8 5s-1.7 4.4-2.3 7.2c0 .3-.1.5-.3.7-.9 1.5-3.8 2.1-5.2 2.1-2.7 0-5.1-.8-5.1-2.7 0-.6 1.1-5.5 5-10.1 1.9-2.3 4.5-4.6 8-6.4z",
  fill: "#f6f7f8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M13 17c3.4-1.7 7.7-3 13.1-2.9 1.6 0 2.9.1 4.6.3.5.1.8.6.7 1.3 0 .3-.2.6-.4.9-.4.4-1 .7-1.8.7-5.5 0-9.6 1.3-12.6 4-1.5 1.3-2.8 3-3.7 5-1 2-1.7 4.4-2.3 7.2 0 .3-.1.5-.3.7-.9 1.5-3.8 2.1-5.2 2.1-2.7 0-5.1-.8-5.1-2.7 0-.6 1.1-5.5 5-10.2 1.9-2.3 4.5-4.6 8-6.4z",
  fill: "#f5f6f7"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M13 17c3.4-1.7 7.7-2.9 13-2.9 1.6 0 2.9.1 4.6.3.5.1.8.6.7 1.3-.1.3-.2.6-.4.9-.4.4-1 .7-1.8.7-5.4 0-9.6 1.3-12.6 4-1.5 1.3-2.8 3-3.7 5-1 2-1.7 4.4-2.3 7.2 0 .3-.1.5-.3.7-.9 1.5-3.8 2.1-5.2 2.1-2.6 0-5.1-.8-5.1-2.7C-.1 33 1 28.1 5 23.4c1.9-2.3 4.5-4.6 8-6.4z",
  fill: "#f4f5f6"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1 17c3.4-1.7 7.7-2.9 13-2.9 1.6 0 2.9.1 4.6.3.5.1.8.6.7 1.3-.1.3-.2.6-.4.9-.4.4-1 .6-1.8.7-5.4 0-9.6 1.3-12.6 4-1.5 1.3-2.8 3-3.7 5-1 2-1.7 4.4-2.3 7.2 0 .3-.1.5-.3.7-.9 1.5-3.7 2.1-5.2 2.1-2.6 0-5.1-.8-5.1-2.7 0-.6 1.1-5.5 5.1-10.2 1.9-2.3 4.4-4.6 8-6.4z",
  fill: "#f3f4f5"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1 17c3.4-1.7 7.7-2.9 13-2.9 1.6 0 2.9.1 4.6.3.5.1.8.6.7 1.3-.1.3-.2.6-.4.9-.4.4-1 .6-1.8.6-5.4 0-9.6 1.3-12.6 4-1.5 1.3-2.8 3-3.7 5-1 2-1.7 4.4-2.3 7.2 0 .3-.1.5-.3.7-.9 1.5-3.7 2.1-5.2 2.1-2.6 0-5.1-.8-5.1-2.7 0-.6 1.1-5.5 5.1-10.2 1.9-2.2 4.5-4.6 8-6.3z",
  fill: "#f2f4f5"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1 17c3.4-1.7 7.7-2.9 13-2.9 1.6 0 2.9.1 4.6.3.5.1.8.6.6 1.3-.1.3-.2.6-.5.9-.4.4-1 .6-1.8.6-5.4 0-9.6 1.3-12.6 4-1.5 1.3-2.8 3-3.7 5-1 2-1.7 4.4-2.3 7.2 0 .3-.1.5-.3.7-.9 1.5-3.7 2.1-5.2 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.5 5.1-10.2 2-2.2 4.6-4.6 8.1-6.3z",
  fill: "#f1f3f4"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2 17c3.4-1.7 7.7-2.9 13-2.9 1.6 0 2.9.1 4.6.3.5.1.8.6.6 1.3-.1.3-.2.6-.5.8-.4.4-1 .6-1.8.6-5.4 0-9.5 1.3-12.6 4-1.5 1.3-2.8 3-3.7 5-1 2-1.7 4.4-2.3 7.2 0 .3-.1.5-.3.7-.9 1.5-3.7 2.1-5.2 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.5 5.1-10.2 1.9-2.1 4.5-4.5 8.1-6.2z",
  fill: "#f0f2f3"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2 17c3.4-1.7 7.6-2.9 12.9-2.9 1.6 0 2.9.1 4.6.3.5.1.7.6.6 1.3-.1.3-.2.6-.5.8-.4.4-1 .6-1.8.6-5.4.1-9.5 1.3-12.6 4-1.5 1.3-2.8 3-3.7 5-1 2-1.7 4.4-2.3 7.2 0 .3-.1.5-.3.7-.9 1.5-3.7 2.1-5.2 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.5 5.1-10.2 2-2.1 4.7-4.5 8.2-6.2z",
  fill: "#eff1f2"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2 16.9c3.4-1.7 7.6-2.9 12.9-2.8 1.6 0 2.9.1 4.6.3.5.1.7.6.6 1.3-.1.3-.2.6-.5.8-.4.4-1 .6-1.8.6-5.4.1-9.5 1.4-12.5 4-1.5 1.3-2.8 3-3.7 5-1 2-1.7 4.4-2.3 7.2 0 .3-.1.5-.3.7-.9 1.5-3.7 2.1-5.2 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.5 5.1-10.2 2-2.1 4.6-4.5 8.1-6.3z",
  fill: "#eef0f1"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3 16.9c3.4-1.7 7.6-2.9 12.9-2.8 1.6 0 2.9.1 4.6.3.5.1.7.6.6 1.3-.1.3-.2.6-.5.8-.4.3-1 .6-1.8.6-5.4.1-9.5 1.4-12.5 4-1.5 1.3-2.7 3-3.7 5s-1.7 4.4-2.3 7.2c0 .3-.1.5-.3.7-.8 1.5-3.6 2.1-5.2 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.5 5.1-10.2 1.9-2.2 4.5-4.5 8.1-6.3z",
  fill: "#edeff1"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3 16.9c3.4-1.7 7.6-2.8 12.9-2.8 1.6 0 2.9.1 4.6.3.5.1.7.6.6 1.3-.1.3-.2.6-.5.8-.4.3-1 .6-1.8.6-5.4.1-9.5 1.4-12.5 4-1.5 1.3-2.7 3-3.7 5s-1.7 4.4-2.3 7.2c0 .3-.1.5-.3.7-.8 1.5-3.6 2.1-5.1 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.5 5.1-10.2 1.8-2.2 4.4-4.5 8-6.3z",
  fill: "#eceef0"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3 16.9c3.4-1.7 7.6-2.8 12.8-2.8 1.6 0 2.9.1 4.6.3.5.1.7.6.6 1.3-.1.3-.2.6-.5.8-.4.3-1 .6-1.8.6-5.4.1-9.5 1.4-12.5 4-1.5 1.3-2.7 3-3.7 5s-1.7 4.4-2.3 7.2c0 .3-.1.5-.3.7-.8 1.5-3.6 2.1-5.1 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.5 5.2-10.2 1.8-2.2 4.5-4.5 8-6.3z",
  fill: "#ebedef"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4 16.9c3.4-1.7 7.6-2.8 12.8-2.8 1.5 0 2.9.1 4.6.3.5.1.7.6.6 1.3-.1.3-.2.6-.5.8-.4.3-1 .6-1.8.6-5.4.1-9.5 1.4-12.5 4-1.5 1.3-2.7 3-3.7 5s-1.7 4.4-2.3 7.2c0 .3-.1.5-.3.7-.8 1.5-3.6 2.1-5.1 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.5 5.2-10.2 1.7-2.2 4.4-4.5 8-6.3z",
  fill: "#eaedee"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4 16.9c3.4-1.7 7.6-2.8 12.8-2.8 1.5 0 2.9.1 4.5.3.4.1.7.6.5 1.3-.1.3-.2.6-.5.8-.4.3-1 .6-1.8.6-5.4.1-9.5 1.4-12.5 4-1.5 1.3-2.7 3-3.7 5s-1.7 4.4-2.3 7.2c0 .3-.1.5-.3.7-.8 1.5-3.6 2.1-5.1 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.5 5.2-10.2 2-2.2 4.6-4.5 8.2-6.3z",
  fill: "#e9eced"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4 16.9c3.4-1.6 7.6-2.8 12.8-2.8 1.5 0 2.9.1 4.5.3.4.1.7.7.5 1.3-.1.3-.2.6-.5.8-.4.3-1 .6-1.8.6-5.4.1-9.5 1.4-12.5 4-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.2c0 .3-.1.5-.3.7-.8 1.5-3.6 2.1-5.1 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.2-10.2 2-2.2 4.6-4.5 8.2-6.3z",
  fill: "#e8ebec"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 16.9c3.4-1.6 7.6-2.8 12.8-2.7 1.5 0 2.9.1 4.5.3.4.1.7.7.5 1.3-.1.3-.2.6-.5.8-.4.3-1 .6-1.8.6-5.4.1-9.5 1.4-12.5 4-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.2c0 .3-.1.5-.2.7-.8 1.5-3.5 2.1-5.1 2.1-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.2-10.3 1.8-2.2 4.5-4.6 8.1-6.3z",
  fill: "#e7eaec"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 16.9c3.4-1.6 7.6-2.8 12.7-2.7 1.5 0 2.9.1 4.5.3.4.1.7.7.5 1.3-.1.3-.2.6-.5.8-.4.3-1 .5-1.8.6-5.4.1-9.5 1.4-12.5 4-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.2c0 .3-.1.5-.2.7-.8 1.5-3.5 2.1-5.1 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.2-10.3 1.9-2.3 4.6-4.7 8.2-6.4z",
  fill: "#e6e9eb"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 16.9c3.4-1.6 7.5-2.7 12.7-2.7 1.5 0 2.9.1 4.5.3.4.1.7.7.5 1.3-.1.3-.3.6-.5.8-.4.3-1 .5-1.8.5-5.4.1-9.5 1.4-12.5 4-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.2c0 .3-.1.5-.2.7-.8 1.5-3.5 2.1-5.1 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.2-10.3 1.9-2.2 4.6-4.6 8.2-6.3z",
  fill: "#e5e8ea"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6 16.9c3.4-1.6 7.5-2.7 12.7-2.7 1.5 0 2.9.1 4.5.3.4.1.7.7.5 1.3-.1.3-.3.6-.5.8-.4.3-1 .5-1.8.5-5.4.1-9.5 1.4-12.4 4-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.2c0 .3-.1.5-.2.7-.8 1.5-3.5 2.1-5.1 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.2-10.3 1.8-2.3 4.4-4.6 8.1-6.3z",
  fill: "#e4e7e9"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6 16.9c3.4-1.6 7.5-2.7 12.7-2.7 1.5 0 2.9.1 4.5.3.4.1.7.7.5 1.3-.1.3-.3.5-.5.7-.4.3-1 .5-1.8.5-5.4.1-9.4 1.4-12.4 4.1-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.2c0 .3-.1.5-.2.7-.8 1.5-3.5 2.2-5.1 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.2-10.3 1.8-2.3 4.5-4.6 8.1-6.3z",
  fill: "#e3e6e8"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6 16.9c3.4-1.6 7.5-2.7 12.6-2.7 1.5 0 2.9.1 4.5.3.4.1.7.7.5 1.3-.1.3-.3.5-.6.7-.4.3-1 .5-1.8.5-5.4.1-9.4 1.4-12.4 4.1-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.2c0 .2-.1.5-.2.7-.8 1.5-3.5 2.2-5.1 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.3-10.3 1.9-2.3 4.6-4.6 8.2-6.3z",
  fill: "#e2e5e8"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7 16.9c3.3-1.6 7.5-2.7 12.6-2.7 1.5 0 2.9.1 4.5.3.4.1.7.7.5 1.3-.1.3-.3.5-.6.7-.4.3-1 .5-1.8.5-5.4.1-9.4 1.4-12.4 4.1-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.2c0 .2-.1.5-.2.7-.8 1.5-3.4 2.2-5.1 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.3-10.3 1.8-2.3 4.5-4.6 8.2-6.3z",
  fill: "#e1e5e7"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7 16.8c3.3-1.6 7.5-2.7 12.6-2.6 1.5 0 2.9.1 4.5.3.4.1.7.7.4 1.3-.1.3-.3.5-.6.7-.4.3-1 .5-1.8.5-5.4.1-9.4 1.4-12.4 4.1-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.1c0 .2-.1.5-.2.7-.7 1.5-3.4 2.2-5 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.3-10.3 1.8-2.2 4.6-4.5 8.2-6.3z",
  fill: "#e0e4e6"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7 16.8c3.3-1.6 7.5-2.7 12.6-2.6 1.5 0 2.8.1 4.5.3.4.1.7.7.4 1.3-.1.3-.3.5-.6.7-.4.3-1 .5-1.8.5-5.4.1-9.4 1.4-12.4 4.1-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.1c0 .2-.1.5-.2.7-.7 1.5-3.4 2.2-5 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.3-10.3 1.9-2.2 4.6-4.5 8.2-6.3z",
  fill: "#dfe3e5"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7 16.8c3.3-1.6 7.5-2.7 12.6-2.6 1.5 0 2.8.1 4.5.3.4.1.7.7.4 1.3-.1.3-.3.5-.6.7-.4.3-1 .5-1.8.5-5.3.1-9.4 1.5-12.4 4.1-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.1c0 .2-.1.5-.2.7-.7 1.5-3.4 2.2-5 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.3-10.3 1.9-2.2 4.6-4.5 8.2-6.3z",
  fill: "#dee2e4"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8 16.8c3.3-1.6 7.5-2.6 12.5-2.6 1.5 0 2.8.1 4.4.3.4.1.6.7.4 1.3-.1.3-.3.5-.6.7-.5.3-1 .5-1.8.5-5.3.1-9.4 1.5-12.4 4.1-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.1c0 .2-.1.5-.2.7-.7 1.5-3.4 2.2-5 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.3-10.3 2-2.2 4.7-4.6 8.4-6.3z",
  fill: "#dde1e4"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8 16.8c3.3-1.6 7.4-2.6 12.5-2.6 1.5 0 2.8.1 4.4.3.4.1.6.7.4 1.3-.1.3-.3.5-.6.7-.5.3-1.1.5-1.8.5-5.3.1-9.4 1.5-12.4 4.1-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.1c0 .2-.1.5-.2.7-.7 1.5-3.4 2.2-5 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.3-10.3 2-2.2 4.8-4.6 8.4-6.3z",
  fill: "#dce0e3"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8 16.8c3.3-1.6 7.4-2.6 12.5-2.6 1.5 0 2.8.1 4.4.3.4.1.6.7.4 1.3-.1.3-.3.5-.6.7-.5.3-1.1.5-1.8.5-5.3.1-9.4 1.5-12.3 4.1-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.1c0 .2-.1.5-.2.7-.7 1.6-3.3 2.2-5 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.3-10.3 1.9-2.2 4.7-4.6 8.3-6.3z",
  fill: "#dbdfe2"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9 16.8c3.3-1.5 7.4-2.6 12.5-2.5 1.5 0 2.8.1 4.4.3.4.1.6.7.4 1.3-.1.3-.3.5-.6.7-.5.3-1.1.5-1.8.5-5.3.1-9.4 1.5-12.3 4.1-1.5 1.3-2.7 3-3.7 5s-1.8 4.4-2.3 7.1c0 .2-.1.5-.2.7-.7 1.6-3.3 2.2-5 2.2-2.6 0-5-.8-5-2.7 0-.6 1.2-5.6 5.4-10.3 1.8-2.4 4.5-4.7 8.2-6.4z",
  fill: "#dadee1"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9 16.8c3.3-1.5 7.4-2.6 12.4-2.5 1.5 0 2.8.1 4.4.3.4.1.6.7.4 1.3-.1.3-.3.5-.6.7-.5.2-1.1.4-1.8.4-5.3.1-9.4 1.5-12.3 4.1-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.7 1.6-3.3 2.2-5 2.2-2.6 0-5-.8-5-2.7 0-.5 1.2-5.6 5.4-10.4 1.9-2.1 4.6-4.4 8.3-6.1z",
  fill: "#d9dee0"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9 16.8c3.3-1.5 7.4-2.6 12.4-2.5 1.5 0 2.8.1 4.4.3.4.1.6.7.4 1.3-.1.3-.3.5-.6.7-.5.2-1.1.4-1.8.4-5.3.1-9.4 1.5-12.3 4.1-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.7 1.6-3.3 2.2-5 2.2-2.6 0-5-.8-5-2.6 0-.5 1.2-5.6 5.4-10.4 1.9-2.2 4.7-4.5 8.3-6.2z",
  fill: "#d8dde0"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M14 16.8c3.3-1.5 7.4-2.6 12.4-2.5 1.5 0 2.8.1 4.4.3.4.1.6.7.3 1.3-.1.3-.3.5-.6.7-.5.2-1.1.4-1.8.4-5.3.1-9.3 1.5-12.3 4.1-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.7 1.6-3.3 2.2-5 2.2-2.6 0-5-.8-5-2.6 0-.5 1.2-5.6 5.4-10.4 1.9-2.2 4.7-4.5 8.4-6.2z",
  fill: "#d7dcdf"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M14 16.8c3.3-1.5 7.4-2.5 12.4-2.5 1.5 0 2.8.1 4.4.3.4.1.6.7.3 1.3-.1.2-.3.5-.6.6-.5.3-1.1.5-1.8.5-5.3.1-9.3 1.5-12.3 4.1-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.7 1.6-3.3 2.2-5 2.2-2.6 0-5-.8-5-2.6 0-.5 1.3-5.6 5.4-10.4 2-2.2 4.7-4.5 8.4-6.2z",
  fill: "#d6dbde"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M14 16.8c3.3-1.5 7.4-2.5 12.4-2.5 1.5 0 2.8.1 4.4.3.4.1.6.7.3 1.3-.1.2-.3.5-.6.6-.5.3-1.1.5-1.9.5-5.3.1-9.3 1.5-12.3 4.1-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.7 1.6-3.2 2.2-5 2.3-2.6 0-5-.8-5-2.6 0-.5 1.3-5.6 5.4-10.4 2.1-2.3 4.8-4.6 8.5-6.3z",
  fill: "#d5dadd"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1 16.8c3.3-1.5 7.4-2.5 12.3-2.5 1.5 0 2.8.1 4.4.3.4.1.6.7.3 1.3-.1.2-.3.5-.6.6-.5.2-1.1.4-1.8.4-5.3.1-9.3 1.5-12.3 4.1-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.7 1.6-3.2 2.2-4.9 2.3-2.6 0-5-.8-5-2.6 0-.5 1.3-5.6 5.4-10.4 1.9-2.2 4.7-4.6 8.4-6.2z",
  fill: "#d4d9dc"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1 16.8c3.3-1.5 7.3-2.5 12.3-2.4 1.5 0 2.8.1 4.4.3.4.1.6.7.3 1.3-.1.2-.3.5-.7.6-.5.2-1.1.4-1.8.4-5.3.1-9.3 1.5-12.3 4.1-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.7 1.6-3.2 2.2-4.9 2.3-2.6 0-5-.8-5-2.6 0-.5 1.3-5.6 5.4-10.4 2-2.3 4.8-4.7 8.5-6.3z",
  fill: "#d3d8dc"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1 16.7c3.3-1.5 7.3-2.5 12.3-2.4 1.5 0 2.8.1 4.4.3.4 0 .6.7.3 1.3-.1.2-.3.5-.7.6-.5.2-1.1.4-1.8.4-5.3.1-9.3 1.5-12.3 4.1-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.6-3.2 2.2-4.9 2.3-2.6 0-5-.8-5-2.6 0-.5 1.3-5.6 5.4-10.4 2-2.2 4.8-4.6 8.5-6.3z",
  fill: "#d2d7db"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2 16.7c3.3-1.5 7.3-2.5 12.3-2.4 1.4 0 2.8.1 4.3.3.4 0 .6.7.3 1.3-.1.2-.3.5-.7.6-.5.2-1.1.4-1.8.4-5.3.1-9.3 1.5-12.2 4.1-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.6-3.2 2.2-4.9 2.3-2.6 0-5-.8-5-2.6 0-.5 1.3-5.6 5.5-10.4 1.9-2.3 4.6-4.6 8.4-6.3z",
  fill: "#d2d7da"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2 16.7c3.3-1.5 7.3-2.5 12.2-2.4 1.4 0 2.8.1 4.3.3.4 0 .6.7.3 1.3-.1.2-.3.5-.7.6-.5.2-1.1.4-1.8.4-5.3.2-9.3 1.5-12.2 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.6-3.2 2.3-4.9 2.3-2.6 0-5-.8-5-2.6 0-.5 1.3-5.6 5.5-10.4 2-2.4 4.8-4.7 8.5-6.4z",
  fill: "#d1d6d9"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2 16.7c3.3-1.5 7.3-2.5 12.2-2.4 1.4 0 2.8.1 4.3.3.4 0 .6.7.3 1.3-.1.2-.3.5-.7.6-.5.2-1.1.4-1.8.4-5.3.2-9.3 1.5-12.2 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.6-3.1 2.3-4.9 2.3-2.6 0-5-.8-5-2.6 0-.5 1.3-5.7 5.5-10.4 2-2.4 4.8-4.7 8.5-6.4z",
  fill: "#d0d5d8"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3 16.7c3.3-1.5 7.3-2.4 12.2-2.4 1.4 0 2.8.1 4.3.3.4 0 .6.7.2 1.3-.1.2-.4.4-.7.6-.5.2-1.1.4-1.8.4-5.3.2-9.3 1.5-12.2 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.6-3.1 2.3-4.9 2.3-2.6 0-5-.8-5-2.6 0-.5 1.3-5.7 5.5-10.4 2-2.4 4.8-4.7 8.6-6.4z",
  fill: "#cfd4d8"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3 16.7c3.3-1.5 7.3-2.4 12.2-2.4 1.4 0 2.8.1 4.3.3.4 0 .6.7.2 1.3-.1.2-.4.4-.7.6-.5.2-1.1.3-1.8.4-5.3.2-9.3 1.6-12.2 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.6-3.1 2.2-4.9 2.3-2.6 0-5-.8-5-2.6 0-.5 1.3-5.7 5.5-10.4 2-2.4 4.8-4.7 8.6-6.4z",
  fill: "#ced3d7"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3 16.7c3.3-1.4 7.3-2.4 12.2-2.3 1.4 0 2.8.1 4.3.3.4 0 .6.7.2 1.3-.1.2-.4.4-.7.6-.5.2-1.1.3-1.8.4-5.3.2-9.3 1.6-12.2 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.5-3.1 2.1-4.9 2.2-2.6 0-5-.8-5-2.6 0-.5 1.3-5.7 5.5-10.4 2.1-2.4 4.9-4.7 8.6-6.4z",
  fill: "#cdd2d6"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4 16.7c3.3-1.4 7.3-2.4 12.1-2.3 1.4 0 2.8.1 4.3.3.4 0 .6.7.2 1.3-.1.2-.4.4-.7.6-.5.2-1.1.3-1.8.4-5.3.2-9.2 1.6-12.2 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.5-3.1 2.1-4.9 2.2-2.5 0-5-.8-5-2.6 0-.5 1.3-5.7 5.5-10.5 2.1-2.3 4.9-4.6 8.7-6.3z",
  fill: "#ccd1d5"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4 16.7c3.3-1.4 7.3-2.4 12.1-2.3 1.4 0 2.8.1 4.3.3.4 0 .6.7.2 1.3-.1.2-.4.4-.7.6-.5.2-1.1.3-1.8.3-5.3.2-9.2 1.6-12.2 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.5-3.1 2.2-4.9 2.3-2.5 0-5-.8-5-2.6 0-.5 1.3-5.7 5.5-10.5 2.1-2.3 4.9-4.7 8.7-6.3z",
  fill: "#cbd0d4"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4 16.7c3.3-1.4 7.2-2.4 12.1-2.3 1.4 0 2.7.1 4.3.3.4 0 .5.7.2 1.3-.1.2-.4.4-.7.5-.5.2-1.1.3-1.8.3-5.3.2-9.2 1.6-12.2 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.6-3 2.3-4.9 2.3-2.5 0-5-.8-5-2.6 0-.5 1.3-5.7 5.5-10.5 2.1-2.2 5-4.6 8.7-6.2z",
  fill: "#cacfd4"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 16.7c3.3-1.4 7.2-2.4 12.1-2.3 1.4 0 2.7.1 4.3.3.4 0 .5.7.2 1.3-.1.2-.4.4-.7.5-.5.2-1.1.3-1.8.3-5.2.2-9.2 1.6-12.2 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.6-3 2.3-4.8 2.3-2.5 0-5-.8-5-2.6 0-.5 1.3-5.7 5.6-10.5 1.8-2.2 4.7-4.6 8.5-6.2z",
  fill: "#c9cfd3"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 16.7c3.3-1.4 7.2-2.3 12-2.3 1.4 0 2.7.1 4.3.3.3 0 .5.7.2 1.3-.2.2-.4.4-.7.5-.5.2-1.1.3-1.8.3-5.2.2-9.2 1.6-12.1 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7.1 0 .2-.1.5-.2.7-.6 1.6-3 2.3-4.8 2.3-2.5 0-5-.8-5-2.6 0-.5 1.3-5.7 5.6-10.5 1.9-2.3 4.7-4.6 8.5-6.2z",
  fill: "#c8ced2"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 16.7c3.3-1.4 7.2-2.3 12-2.3 1.4 0 2.7.1 4.3.3.3 0 .5.7.1 1.3-.2.2-.4.4-.7.5-.5.2-1.1.3-1.8.3-5.2.2-9.2 1.6-12.1 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.6 1.6-3 2.3-4.8 2.3-2.5 0-5-.8-5-2.6 0-.5 1.3-5.7 5.6-10.5 2-2.2 4.8-4.5 8.6-6.1z",
  fill: "#c7cdd1"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6 16.7c3.2-1.4 7.2-2.3 12-2.2 1.4 0 2.7.1 4.2.3.3 0 .5.8.1 1.3-.2.2-.4.4-.7.5-.5.2-1.1.3-1.8.3-5.2.2-9.2 1.6-12.1 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.6 1.6-3 2.3-4.8 2.3-2.5 0-5-.8-5-2.6 0-.5 1.3-5.7 5.6-10.5 2-2.3 4.9-4.6 8.7-6.2z",
  fill: "#c6ccd0"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6 16.6c3.2-1.4 7.2-2.3 12-2.2 1.4 0 2.7.1 4.2.3.3 0 .5.8.1 1.3-.2.2-.4.4-.8.5-.5.2-1.1.3-1.8.3-5.2.2-9.2 1.6-12.1 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.5 1.6-3 2.3-4.8 2.4-2.5 0-5-.8-5-2.6 0-.5 1.3-5.7 5.6-10.5 2.1-2.3 5-4.6 8.8-6.3z",
  fill: "#c5cbd0"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6 16.6c3.2-1.4 7.2-2.3 11.9-2.2 1.4 0 2.7.1 4.2.3.3 0 .5.8.1 1.3-.2.2-.4.4-.8.5-.5.2-1.1.3-1.8.3C23 17 19 18.4 16.1 21c-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.5 1.6-2.9 2.3-4.8 2.4-2.5 0-5-.8-5-2.6 0-.5 1.3-5.7 5.6-10.5 2.2-2.3 5.1-4.6 8.9-6.3z",
  fill: "#c4cacf"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7 16.6c3.2-1.4 7.2-2.3 11.9-2.2 1.4 0 2.7.1 4.2.3.3 0 .5.8.1 1.3-.2.2-.4.4-.8.5-.5.1-1.2.3-1.8.3-5.2.2-9.2 1.6-12.1 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.5 1.6-2.9 2.3-4.8 2.4-2.5 0-5-.8-5-2.6 0-.5 1.3-5.7 5.6-10.5 2.2-2.3 5-4.6 8.9-6.3z",
  fill: "#c3c9ce"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7 16.6c3.2-1.4 7.2-2.3 11.9-2.2 1.4 0 2.7.1 4.2.3.3 0 .5.8.1 1.3-.2.2-.4.4-.8.5-.5.1-1.2.3-1.8.3-5.2.2-9.2 1.6-12.1 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.5 1.6-2.9 2.3-4.8 2.4-2.5.1-5-.8-5-2.6 0-.5 1.3-5.7 5.6-10.5 2.2-2.3 5.1-4.6 8.9-6.3z",
  fill: "#c2c8cd"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7 16.6c3.2-1.4 7.1-2.3 11.9-2.2 1.4 0 2.7.1 4.2.3.3 0 .5.8.1 1.3-.2.2-.4.4-.8.5-.5.1-1.2.2-1.8.3-5.2.2-9.2 1.6-12.1 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.5 1.6-2.9 2.3-4.8 2.4-2.5.1-5-.8-5-2.6 0-.5 1.3-5.7 5.6-10.5 2.2-2.3 5.1-4.7 8.9-6.3z",
  fill: "#c1c8cc"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8 16.6c3.2-1.4 7.1-2.2 11.9-2.1 1.4 0 2.7.1 4.2.3.3 0 .5.8.1 1.3-.2.2-.4.4-.8.5l-1.8.3c-5.2.2-9.2 1.6-12.1 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.5 1.6-2.9 2.3-4.8 2.4-2.5.1-5-.8-5-2.6C.3 33 1.6 27.8 6 23c2-2.4 4.9-4.8 8.8-6.4z",
  fill: "#c0c7cc"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8 16.6c3.2-1.4 7.1-2.2 11.8-2.1 1.4 0 2.7.1 4.2.3.3 0 .5.8.1 1.3-.2.2-.4.4-.8.5l-1.8.3c-5.2.2-9.1 1.6-12.1 4.2-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.5 1.6-2.9 2.3-4.8 2.4-2.5.1-5-.8-5-2.6 0-.5 1.3-5.7 5.7-10.5 2.1-2.5 5-4.8 8.9-6.4z",
  fill: "#bfc6cb"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8 16.6c3.2-1.3 7.1-2.2 11.8-2.1 1.4 0 2.7.1 4.2.3.3 0 .5.8 0 1.3-.2.2-.4.4-.8.5-.6.1-1.2.2-1.8.2-5.2.2-9.1 1.7-12 4.3-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.5 1.6-2.8 2.3-4.8 2.4-2.5.1-5-.8-5-2.6 0-.5 1.3-5.7 5.7-10.6 2.2-2.4 5.1-4.7 8.9-6.3z",
  fill: "#bec5ca"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 16.6c3.2-1.3 7.1-2.2 11.8-2.1 1.4 0 2.7.1 4.2.3.3 0 .5.8 0 1.3-.2.2-.4.4-.8.4-.6.1-1.2.2-1.8.2-5.2.2-9.1 1.7-12 4.3-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.5 1.6-2.8 2.3-4.7 2.4-2.5.1-5-.8-5-2.6 0-.5 1.4-5.7 5.7-10.6 2-2.3 4.9-4.6 8.8-6.2z",
  fill: "#bdc4c9"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 16.6c3.2-1.3 7.1-2.2 11.8-2.1 1.4 0 2.7.1 4.2.3.3 0 .5.8 0 1.3-.2.2-.4.4-.8.4-.6.1-1.2.2-1.8.2-5.2.2-9.1 1.7-12 4.3-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.6 1.7-2.9 2.4-4.8 2.4-2.5.1-5-.8-5-2.6 0-.5 1.4-5.7 5.7-10.6 2.1-2.3 5-4.6 8.9-6.2z",
  fill: "#bcc3c8"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 16.6c3.2-1.3 7.1-2.2 11.7-2.1 1.4 0 2.7.1 4.2.3.3 0 .5.8 0 1.3-.2.2-.4.4-.8.4-.6.1-1.2.2-1.9.2-5.1.3-9.1 1.8-12 4.3-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.4 1.7-2.7 2.4-4.6 2.4-2.5.1-5-.8-5-2.6 0-.5 1.4-5.7 5.7-10.6 2.1-2.3 5-4.6 8.9-6.2z",
  fill: "#bbc2c8"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 16.6c3.2-1.3 7.1-2.2 11.7-2.1 1.4 0 2.7.1 4.1.3.3 0 .5.8 0 1.3-.2.2-.4.4-.8.4-.6.1-1.2.2-1.9.2-5 .3-9 1.7-11.9 4.3-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.4 1.6-2.7 2.4-4.6 2.4-2.5.1-5-.8-5-2.6 0-.5 1.4-5.7 5.7-10.6 2.1-2.3 5.1-4.6 8.9-6.2z",
  fill: "#bac1c7"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M15 16.6c3.2-1.3 7.1-2.1 11.7-2 1.3 0 2.7.1 4.1.3.3 0 .5.8 0 1.3-.2.2-.4.3-.8.4-.6.1-1.2.2-1.9.2-5.2.2-9.1 1.7-12 4.3-1.5 1.3-2.7 3-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.4 1.5-2.7 2.3-4.6 2.3-2.5.1-5-.8-5-2.6 0-.5 1.4-5.7 5.7-10.6 2.2-2.3 5.1-4.6 9-6.2z",
  fill: "#b9c0c6"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M15 16.6c3.2-1.3 7-2.1 11.7-2 1.3 0 2.7.1 4.1.3.3 0 .5.8 0 1.3-.2.2-.4.3-.8.4-.6.1-1.2.2-1.9.2-5.2.2-9.1 1.7-12 4.3-1.5 1.3-2.7 2.9-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.4 1.5-2.7 2.3-4.6 2.3-2.5.1-5-.8-5-2.6 0-.5 1.4-5.7 5.8-10.6 2.1-2.3 5-4.7 8.9-6.2z",
  fill: "#b8c0c5"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M15 16.5c3.2-1.3 7-2.1 11.7-2 1.3 0 2.7.1 4.1.3.3 0 .5.8 0 1.3-.2.2-.5.3-.8.4-.6.1-1.2.2-1.9.2-5.2.2-9.1 1.7-12 4.3-1.5 1.3-2.7 2.9-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.4 1.6-2.6 2.4-4.6 2.4-2.5.1-5-.8-5-2.6 0-.5 1.4-5.8 5.8-10.6 2.1-2.3 5-4.7 8.9-6.3z",
  fill: "#b7bfc4"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 16.5c3.2-1.3 7-2.1 11.6-2 1.3 0 2.7.1 4.1.3.3 0 .5.8 0 1.3-.2.2-.5.3-.8.4-.6.1-1.2.2-1.9.2-5.2.2-9.1 1.7-12 4.3-1.5 1.3-2.7 2.9-3.7 4.9-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.4 1.6-2.6 2.4-4.6 2.4-2.5.1-5-.8-5-2.6 0-.5 1.4-5.8 5.8-10.6 2.1-2.4 5.1-4.7 9-6.3z",
  fill: "#b6bec3"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 16.5c3.2-1.3 7-2.1 11.6-2 1.3 0 2.7.1 4.1.3.3 0 .5.8-.1 1.3-.2.2-.5.3-.9.4-.6.1-1.2.2-1.9.2-5 .3-8.9 1.7-11.8 4.3-1.5 1.3-2.7 2.9-3.7 4.8-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.4 1.7-2.6 2.5-4.6 2.5-2.5.1-5-.8-5-2.6 0-.5 1.4-5.8 5.8-10.6 2.2-2.4 5.1-4.7 9-6.3z",
  fill: "#b5bdc3"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 16.5c3.2-1.3 7-2.1 11.6-2 1.3 0 2.7.1 4.1.3.3 0 .4.8-.1 1.3-.2.2-.5.3-.9.4-.6.1-1.2.1-1.9.2-5 .3-8.9 1.7-11.8 4.3-1.5 1.3-2.7 2.9-3.7 4.8-1 2-1.8 4.4-2.3 7 0 .2-.1.5-.2.7-.4 1.7-2.6 2.5-4.6 2.5-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.8-10.6 2.2-2.4 5.1-4.7 9-6.3z",
  fill: "#b4bcc2"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2 16.5c3.2-1.3 7-2.1 11.6-2 1.3 0 2.6.1 4.1.3.3 0 .4.8-.1 1.3-.2.2-.5.3-.9.4-.6.1-1.2.1-1.9.2-5.1.2-9 1.7-11.9 4.3-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 7 0 .2-.1.5-.2.7-.5 1.7-2.7 2.5-4.7 2.5-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.8-10.6 2.2-2.4 5.2-4.7 9.1-6.3z",
  fill: "#b3bbc1"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2 16.5c3.2-1.3 7-2.1 11.5-1.9 1.3 0 2.6.1 4.1.3.3 0 .4.8-.1 1.3-.2.2-.5.3-.9.4-.6.1-1.2.1-1.9.2-5.1.3-9 1.7-11.9 4.3-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 7 0 .2-.1.5-.2.7-.4 1.6-2.6 2.4-4.6 2.4-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.8-10.6 2.2-2.4 5.2-4.7 9.1-6.3z",
  fill: "#b2bac0"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2 16.5c3.2-1.3 7-2 11.5-1.9 1.3 0 2.6.1 4.1.3.3 0 .4.8-.1 1.3-.2.2-.5.3-.9.4-.6.1-1.2.1-1.9.2-5.1.3-9 1.7-11.9 4.3-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 7 0 .2-.1.5-.2.7-.4 1.6-2.6 2.4-4.6 2.4-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.8-10.6 2.2-2.4 5.2-4.7 9.1-6.3z",
  fill: "#b1b9bf"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3 16.5c3.2-1.3 7-2 11.5-1.9 1.3 0 2.6.1 4.1.3.3 0 .4.8-.1 1.3-.2.2-.5.3-.9.3-.6.1-1.2.1-1.9.1-5.1.3-9 1.7-11.9 4.3-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 7 0 .2-.1.5-.2.7-.5 1.8-2.7 2.6-4.7 2.6-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.8-10.7 2.3-2.3 5.2-4.6 9.2-6.2z",
  fill: "#b0b9bf"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3 16.5c3.2-1.3 7-2 11.5-1.9 1.3 0 2.6.1 4.1.3.3 0 .4.8-.1 1.3-.2.2-.5.3-.9.3-.6.1-1.2.1-1.9.1-5.1.3-9 1.7-11.9 4.3-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 7 0 .2-.1.5-.2.7-.5 1.8-2.7 2.6-4.7 2.6-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.9-10.7 2.2-2.3 5.2-4.7 9.1-6.2z",
  fill: "#afb8be"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3 16.5c3.2-1.2 6.9-2 11.5-1.9 1.3 0 2.6.1 4 .3.3 0 .4.8-.1 1.3-.2.2-.5.3-.9.3-.6 0-1.2.1-1.9.1-5.1.3-9 1.7-11.9 4.3-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 7 0 .2-.1.5-.2.7-.4 1.8-2.5 2.6-4.6 2.6-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.9-10.7 2.2-2.3 5.2-4.7 9.1-6.2z",
  fill: "#aeb7bd"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4 16.5c3.2-1.2 6.9-2 11.4-1.9 1.3 0 2.6.1 4 .3.3 0 .4.8-.2 1.3-.2.2-.5.3-.9.3-.6 0-1.2.1-1.9.1-5.1.3-9 1.8-11.9 4.3-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 7 0 .2-.1.5-.2.7-.3 1.8-2.4 2.6-4.5 2.6-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.9-10.7 2.2-2.3 5.2-4.7 9.2-6.2z",
  fill: "#adb6bc"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4 16.5c3.2-1.2 6.9-2 11.4-1.9 1.3 0 2.6.1 4 .3.3 0 .4.8-.2 1.3-.2.2-.5.3-.9.3-.6 0-1.2.1-1.9.1-5.1.3-9 1.8-11.9 4.3-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 6.9 0 .2-.1.5-.2.7-.3 1.9-2.4 2.7-4.5 2.7-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.9-10.7 2.2-2.4 5.2-4.7 9.2-6.2z",
  fill: "#acb5bb"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4 16.5c3.1-1.2 6.9-2 11.4-1.8 1.3 0 2.6.1 4 .3.3 0 .4.9-.2 1.3-.2.2-.5.3-.9.3-.6 0-1.2.1-1.9.1-5.1.3-9 1.8-11.8 4.4-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 6.9 0 .2-.1.5-.2.7-.4 1.7-2.5 2.5-4.6 2.5-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.9-10.7 2.3-2.4 5.3-4.7 9.2-6.2z",
  fill: "#abb4bb"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 16.5c3.1-1.2 6.9-1.9 11.4-1.8 1.3 0 2.6.1 4 .3.3 0 .4.9-.2 1.3-.2.2-.5.3-.9.3-.6 0-1.3.1-1.9.1-5.1.3-9 1.8-11.8 4.4-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 6.9 0 .2-.1.5-.2.7-.5 1.7-2.6 2.5-4.7 2.5-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.9-10.7 2.3-2.4 5.3-4.7 9.3-6.2z",
  fill: "#aab3ba"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 16.4c3.1-1.2 6.9-1.9 11.3-1.8 1.3 0 2.6.1 4 .3.3 0 .4.9-.2 1.3-.2.2-.5.3-.9.3-.6 0-1.3.1-1.9.1-5.1.3-9 1.8-11.8 4.4-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 6.9 0 .2-.1.5-.2.7-.3 1.7-2.5 2.5-4.6 2.5-2.5.1-5-.8-5-2.6 0-.4 1.4-5.8 5.9-10.7 2.3-2.3 5.3-4.6 9.3-6.2z",
  fill: "#a9b2b9"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 16.4c3.1-1.2 6.9-1.9 11.3-1.8 1.3 0 2.6.1 4 .3.3 0 .4.9-.2 1.3-.2.2-.5.3-.9.3-.6 0-1.3 0-1.9.1-5.1.3-9 1.8-11.8 4.4-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 6.9 0 .2-.1.5-.1.7-.3 1.7-2.5 2.5-4.6 2.5-2.5.1-5-.8-5-2.5 0-.4 1.4-5.8 5.9-10.7 2.2-2.4 5.2-4.7 9.2-6.3z",
  fill: "#a8b2b8"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6 16.4c3.1-1.2 6.9-1.9 11.3-1.8 1.3 0 2.6.1 4 .3.2 0 .4.9-.2 1.3-.2.2-.5.3-.9.3-.6 0-1.3 0-1.9.1-5.1.3-9 1.8-11.8 4.4-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 6.9 0 .2-.1.5-.1.7-.3 1.7-2.5 2.5-4.6 2.5-2.5.1-5-.8-5-2.5 0-.4 1.4-5.8 5.9-10.7 2.1-2.4 5.2-4.7 9.2-6.3z",
  fill: "#a7b1b7"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6 16.4c3.1-1.2 6.9-1.9 11.3-1.8 1.3 0 2.6.1 4 .3.2 0 .4.9-.2 1.3-.2.2-.5.3-1 .3-.6 0-1.3 0-1.9.1-5.1.3-8.9 1.8-11.8 4.4-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 6.9 0 .2-.1.5-.1.7-.3 1.7-2.4 2.5-4.6 2.5-2.5.1-5-.8-5-2.5 0-.4 1.4-5.8 6-10.7 2.2-2.4 5.2-4.8 9.2-6.3z",
  fill: "#a6b0b7"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6 16.4c3.1-1.2 6.8-1.9 11.3-1.7 1.3 0 2.6.1 4 .3.2 0 .4.9-.2 1.3-.2.2-.5.3-1 .3-.6 0-1.3 0-1.9.1-5.1.3-8.9 1.8-11.8 4.4-1.5 1.3-2.7 2.9-3.6 4.8-1 2-1.8 4.3-2.3 6.9 0 .2-.1.5-.1.7-.3 1.7-2.4 2.5-4.5 2.5-2.5.1-5-.8-5-2.5 0-.4 1.4-5.8 6-10.7 2.1-2.5 5.1-4.9 9.1-6.4z",
  fill: "#a5afb6"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9 15c-6.2-.8-11.2-.1-15.2 1.4s-7.1 3.8-9.3 6.3C1.9 27.6.4 33 .4 33.4c0 3.2 8.8 3.6 9.5 0 1-5.3 2.9-9.6 6.1-12.4s7.6-4.4 13.7-4.4c1.6 0 1.5-1.6 1.2-1.6z",
  fill: "#a4aeb5"
});

var _ref95 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo-recruit-sp_svg__SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 0.259,
  y1: 12.581,
  x2: 26.621,
  y2: 24.874
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#54c2f0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.025,
  stopColor: "#49b9eb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.124,
  stopColor: "#219ada"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.202,
  stopColor: "#0987cf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#0080cb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#0068b6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#005bab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#004da0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.2 0C9.9 0 0 4.4 0 18.3v15.3c0 3.5 9.8 3.5 9.8 0V17.8c0-6.5 4.1-11.4 9.8-11.5 4.5-.1 8.2 2.2 8.2 8.8 0 1.7 3.3 1.7 3.3 0C31.1 3.9 24.9 0 17.2 0z",
  fill: "url(#logo-recruit-sp_svg__SVGID_1_)"
}));

var _ref96 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "logo-recruit-sp_svg__st94",
  d: "M40.9 35.4h-3.6c-.3 0-.4-.2-.6-.4l-4.2-5.7H32c-.8 0-1.9-.1-2.6-.1V35c0 .2-.2.4-.6.4h-2.9c-.3 0-.6-.2-.6-.4V20.3c0-.4.4-.6.9-.6 1.5-.2 3.6-.3 5.8-.3 4.5 0 8.5 1.2 8.5 4.8v.2c0 2.3-1.6 3.7-4 4.4l4.6 6.2c.2.2.1.4-.2.4zm-4.5-11.2c0-1.6-1.5-2.3-4.4-2.3-.6 0-2.1 0-2.6.1v4.8c.5 0 2.1.1 2.6.1 3 0 4.4-.6 4.4-2.5v-.2zM56.6 35.3c-.9.1-2.1.3-5.6.3-3.8 0-6.8-.7-6.8-4.4v-7.5c0-3.6 3-4.4 6.8-4.4 3.5 0 4.6.2 5.6.3.4 0 .6.2.6.4v1.4c0 .2-.3.4-.6.4h-6c-1.7 0-2.3.4-2.3 1.8v2.3h8c.3 0 .6.2.6.4V28c0 .2-.3.4-.6.4h-8v2.8c0 1.4.6 1.8 2.3 1.8h6c.3 0 .6.2.6.4v1.4c0 .3-.2.4-.6.5zM73.2 35.2c-.4.1-2.4.3-4.6.3-3.5 0-8.3-1.3-8.3-6.5v-3.1c0-5.4 4.8-6.5 8.3-6.5 2.3 0 4.2.3 4.6.3.4.1.6.2.6.5v1.4c0 .3-.2.5-.6.4-1-.1-3-.2-4.6-.2-2.5 0-4.3 1-4.3 4v3.1c0 3 1.8 4 4.3 4 1.6 0 3.6-.1 4.6-.2.5 0 .6.2.6.4v1.4c0 .6-.2.7-.6.7zM92.6 35.4H89c-.3 0-.4-.2-.6-.4l-4.2-5.7h-.4c-.8 0-1.9-.1-2.6-.1V35c0 .2-.2.4-.6.4h-2.9c-.3 0-.6-.2-.6-.4V20.3c0-.4.4-.6.9-.6 1.5-.2 3.6-.3 5.8-.3 4.5 0 8.5 1.2 8.5 4.8v.2c0 2.3-1.6 3.7-4 4.4l4.6 6.2c.1.2 0 .4-.3.4zm-4.4-11.2c0-1.6-1.5-2.3-4.4-2.3-.6 0-2.1 0-2.6.1v4.8c.5 0 2.1.1 2.6.1 3 0 4.4-.6 4.4-2.5v-.2zM109.9 35.2c-1 .1-4.7.4-6.5.4-4.7 0-8-1.5-8-6V20c0-.2.3-.4.6-.4h2.9c.3 0 .6.2.6.4v9.6c0 2.4.8 3.5 3.9 3.5 1.2 0 3-.1 4.1-.2V20c0-.2.2-.4.6-.4h2.9c.3 0 .6.2.6.4v14c-.1.8-.6 1.1-1.7 1.2zM119.1 35.4h-2.9c-.3 0-.6-.2-.6-.4V20c0-.2.3-.4.6-.4h2.9c.3 0 .6.2.6.4v15c0 .2-.3.4-.6.4zM137.4 22h-5.1v13c0 .2-.3.4-.6.4h-2.9c-.3 0-.6-.2-.6-.4V22h-5.1c-.3 0-.6-.1-.6-.4V20c0-.2.3-.4.6-.4h14.4c.3 0 .6.2.6.4v1.7c-.1.2-.4.3-.7.3z"
}));

var _ref97 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "logo-recruit-sp_svg__st94",
  d: "M2.5 55.4v-6.7c0-.2-.2-.3-.4-.3H.4c-.2 0-.4.1-.4.3v6.7c0 .2.2.3.4.3h1.8c.2 0 .3-.1.3-.3zM9.6 48.5H7.8c-.2 0-.4.1-.4.3v4.7c0 3.7-1.8 4.3-5 4.8-.4.1-.5.1-.5.4v1.1c0 .3.1.4.5.3 5.8-.4 7.5-2.3 7.5-6.4v-4.9c.1-.2-.1-.3-.3-.3zM60 53.4c-1.9-.5-4.4-1-6.9-1.5v-3.6c0-.2-.2-.3-.4-.3h-1.9c-.2 0-.4.1-.4.3v11.3c0 .2.2.3.4.3h1.9c.2 0 .4-.1.4-.3v-5.9c2.4.5 4.8 1.1 6.8 1.6.4.1.5 0 .5-.3v-1c0-.3 0-.5-.4-.6zM29 48.5h-1.6c-.2 0-.4.1-.4.3v3.9c0 3.2-.7 4.4-1.6 5.3-.3.3-.4.4-.4.8v.9c0 .3.2.3.5.2 2.6-.8 3.8-3 3.8-7.1v-4c0-.2-.1-.3-.3-.3zM32.7 59.8c3.2 0 4.9-2.7 5.5-6.4.1-.4 0-.5-.3-.5h-1.3c-.3 0-.4.1-.5.5-.5 2.1-1.1 3.4-2.3 4-.3.2-.6.1-.6-.3v-8.4c0-.2-.2-.3-.4-.3h-1.6c-.2 0-.4.1-.4.3v9.7c.2 1.1.7 1.4 1.9 1.4zM48.3 53h-8c-.3 0-.4.1-.4.3v1.4c0 .1.1.3.4.3h8c.3 0 .4-.1.4-.3v-1.4c-.1-.2-.2-.3-.4-.3zM22.6 48.5h-7.2c-.6 0-.8.2-.9.7-.4 1.8-1.2 2.9-2.3 3.5-.4.3-.5.4-.5.6v1c0 .3.1.3.5.3 1.9-.3 3.4-1.4 4.4-4 .1-.3.3-.3.7-.3h3.4c.2 0 .5.1.5.5-.3 5-2.5 6.8-6.8 7.5-.4.1-.5.1-.5.4v1.1c0 .3.1.4.5.3 5.9-.4 9.3-2.9 9.3-10.4.1-.8-.2-1.2-1.1-1.2z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "logo-recruit-sp_svg__st94",
  d: "M109.5 49h-9.8c-.3 0-.4.1-.4.3v1.2c0 .1.1.3.4.3h8c.2 0 .5.2.5.5-.1 4.9-2.7 6.2-7.2 6.8-.4.1-.5.2-.5.4v1.1c0 .3.1.3.5.3 6.3-.4 9.6-2.6 9.7-8.6v-.9c.1-1-.2-1.4-1.2-1.4zM89.4 51.5c.2 1.2.4 2.6.5 3.7 0 .3.1.4.4.4h1.4c.2 0 .4-.1.3-.4-.2-1.2-.6-2.7-.8-3.7-.1-.3-.2-.3-.4-.3h-1.1c-.3-.1-.4 0-.3.3zM92.6 51.5c.1 1.3.2 2.6.3 3.7 0 .3.1.4.3.4h1.4c.2 0 .4-.1.3-.4-.2-1.2-.5-2.7-.7-3.7-.1-.3-.2-.3-.4-.3h-1.1c0-.1-.1 0-.1.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-recruit-sp_svg__st94",
  d: "M98.4 51.4c-.1 5.8-1.8 7.7-7.2 8.5-.4.1-.4 0-.4-.3v-.9c0-.2.1-.3.4-.4 4.1-.9 5-2.2 5.2-7 0-.2.1-.3.4-.3h1.4c.1.1.3.2.2.4zM122.8 48.9c1.4-.1 3.7 0 5 .1.4 0 .4.2.4.5v1.3c0 .3-.1.5-.5.5-1.4-.1-3.7-.3-4.9-.4-.4 0-.5-.1-.5-.4v-1.2c.1-.3.2-.4.5-.4zM122.9 59.8c7.3 0 10.2-1.8 10.9-8.4 0-.4 0-.5-.3-.5h-1.3c-.3 0-.4.1-.5.5-.8 5-2.3 6.3-8.8 6.5-.4 0-.4.1-.4.4v1.2c-.1.2 0 .3.4.3zM120.9 50.5h-1.8c-.3 0-.4.1-.6.3-1.3 2.1-3.2 3.3-6.6 3.8-.3 0-.4.1-.4.3v1c0 .2.1.3.4.3 1.4-.1 2.7-.3 3.8-.7v4.2c0 .1.1.2.3.2h1.6c.2 0 .3-.1.3-.2v-5.3c1.3-.8 2.4-2 3-3.5.3-.2.2-.4 0-.4zM86.8 48.5h-7.2c-.6 0-.8.2-.9.7-.4 1.8-1.2 2.9-2.3 3.5-.4.3-.4.4-.4.7v1c0 .3.1.3.5.3 1.9-.3 3.4-1.4 4.4-4 .1-.3.3-.3.7-.3H85c.2 0 .5.1.5.5-.1 1.2-.3 2.3-.5 3.1l-4.4-1c-.3-.1-.4 0-.4.2v1.2c0 .2.1.3.4.4l3.5.7c-1.1 1.6-2.9 2.3-5.4 2.7-.4.1-.5.1-.5.4v1.1c0 .3.1.4.5.3 5.9-.4 9.3-2.9 9.3-10.4 0-.7-.3-1.1-1.2-1.1zM75.3 57.4l-3.1-2.5c.9-1.4 1.6-3 1.9-5 .1-.7-.2-1.2-1-1.2h-7.8c-.3 0-.4.1-.4.3v1.2c0 .1.1.3.4.3H71c.2 0 .4.1.3.4-.8 3.4-3.1 5.6-6.7 7.2-.4.2-.5.3-.5.5v1.1c0 .3.1.3.5.2 2.5-.7 4.6-1.9 6.3-3.5l4.3 3.5c.2.2.5.1.5-.2v-1.6c0-.3-.1-.5-.4-.7z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "logo-recruit-sp_svg__st94",
  d: "M146.2 50.5c-.2 0-.4-.2-.4-.4v-1.6h-7.5c-.6 0-.8.2-.9.7-.4 1.8-1.2 2.9-2.3 3.5-.4.3-.5.4-.5.6v1c0 .3.1.3.5.3 1.9-.3 3.4-1.4 4.4-4 .1-.3.3-.3.7-.3h3.4c.2 0 .5.1.5.5-.3 5-2.5 6.8-6.8 7.5-.4.1-.5.1-.5.4v1.1c0 .3.1.4.5.3 5.7-.4 9-2.7 9.3-9.5h-.4zM147.5 47.2h-.5c-.2 0-.3.1-.3.3V50c0 .1.2.3.3.3h.5c.2 0 .3-.1.3-.3v-2.6c.1-.1-.1-.2-.3-.2zM149.7 47.2h-.5c-.2 0-.3.1-.3.3V50c0 .1.2.3.3.3h.5c.2 0 .3-.1.3-.3v-2.6c0-.1-.2-.2-.3-.2z"
}))));

var SvgLogoRecruitSp = function SvgLogoRecruitSp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-recruit-sp_svg__layer",
    x: 0,
    y: 0,
    width: 150,
    height: 60,
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97);
};

export default SvgLogoRecruitSp;